import React, { useEffect, useState } from 'react';
import { getAllStickies } from '../../../../Core/Services/InternalUser/ControllerService/noteService';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import './NotesandSticky.scss';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import WorkIcon from '@material-ui/icons/Work';
import WarningIcon from '@material-ui/icons/Warning';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(1)
        }
    }
}));

export const StickyNotes = (props) => {
    const classes = useStyles();
    const [state, setState] = useState({
        stickyList: []
    });

    useEffect(() => {
        const fetchStickies = async () => {
            // Check if required props are provided before fetching stickies
            if (
                props.frompage &&
                (props.NoteVehicleID || props.NoteServiceAgID || props.customerID || props.NoteDriverID || props.noteRefsGuidID || props.depotID)
            ) {
                try {
                    const res = await getAllStickies(
                        props.frompage,
                        props.NoteVehicleID,
                        props.NoteServiceAgID,
                        props.customerID,
                        props.NoteDriverID,
                        props.noteRefsGuidID,
                        props.depotID
                    );
                    setState((st) => ({ ...st, stickyList: res.data || [] }));
                } catch (error) {
                    console.error('Error fetching stickies:', error);
                }
            }
        };

        fetchStickies();
    }, [props.frompage, props.NoteVehicleID, props.NoteServiceAgID, props.customerID, props.NoteDriverID, props.noteRefsGuidID, props.depotID]);

    return (
        <div className="alert-container">
            {state.stickyList.length > 0 &&
                state.stickyList.map((q, index) => (
                    <Alert
                        key={q.id || index}
                        variant={props.variant || 'standard'}
                        className="alert-items"
                        style={{ backgroundColor: props.bgColor ? props.bgColor : '' }}
                        severity="warning"
                        icon={
                            props.frompage == 'Depots' ? (
                                <LocalShippingIcon fontSize="inherit" style={{ color: props.bgColor ? 'black' : 'white' }} />
                            ) : props.frompage == 'Customers' ? (
                                <PermContactCalendarIcon fontSize="inherit" style={{ color: props.bgColor ? 'black' : 'white' }} />
                            ) : props.frompage == 'Jobs' ? (
                                <WorkIcon fontSize="inherit" style={{ color: props.bgColor ? 'black' : 'white' }} />
                            ) : props.frompage == 'Vehicle' ? (
                                <DriveEtaIcon fontSize="inherit" style={{ color: props.bgColor ? 'black' : 'white' }} />
                            ) : (
                                <WarningIcon fontSize="inherit" style={{ color: props.bgColor ? 'black' : 'white' }} />
                            )
                        }
                    >
                        {q.title}
                        {q.createdBy ? ` (${q.createdBy})` : ''}
                        <br />
                        {q.description}
                    </Alert>
                ))}
        </div>
    );
};

export default StickyNotes;
